module.exports = __webpack_public_path__ + "img/noData.63f843bf.png";